/** Tracker entity identity and editor support. For Media Devoted | Created By Ciro Autiero */
import { matchTracker, trackerCan, type TrackerId } from '@trafficpulse/shared';
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const NATIVE = { lander: /^lnd_[0-9A-HJKMNP-TV-Z]{26}$/, offer: /^off_[0-9A-HJKMNP-TV-Z]{26}$/ };
export function validEntityId(provider: TrackerId | null, kind: 'lander' | 'offer', id: string): boolean {
  return matchTracker(provider ?? 'voluum', {
    voluum: () => UUID.test(id), binom: () => UUID.test(id),
    'tres-commas': () => UUID.test(id) || NATIVE[kind].test(id),
  });
}
export function entityIdCopy(provider: TrackerId | null) {
  const legacy = () => ({ label: 'ID (UUID)', example: '00000000-0000-0000-0000-000000000000', kind: 'UUID' });
  return matchTracker(provider ?? 'voluum', { voluum: legacy, binom: legacy,
    'tres-commas': () => ({ label: 'ID', example: 'Paste the Tres Commas entity ID', kind: 'ID' }) });
}
export function tcEntityEditorEnabled(provider: TrackerId | null): boolean {
  return provider ? matchTracker(provider, { voluum: () => false, binom: () => false,
    'tres-commas': () => trackerCan('tres-commas', 'bankWrites') }) : false;
}
